import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default class StickySlides {

    constructor(el) {
        this.el = el;

        if(!this.el) {
            return;
        }

        const pinElm = this.el.querySelector('[data-text-wrapper]');

        ScrollTrigger.create({
            trigger: this.el,
            start: "top top",
            end: "bottom bottom",
            pin: pinElm,
            pinSpacing: false,
        });

        const slides = this.el.querySelectorAll('[data-slide-image]');

        const slidesArr = gsap.utils.toArray(slides);

        slidesArr.forEach((slide, i) => {

            ScrollTrigger.create({
                trigger: slide,
                start: "-200px top",
                end: "250px top",
                toggleActions: 'restart pause reverse pause',
                onEnter: () => {
                    const slideKey = slide.getAttribute('data-slide-image');
                    const targetText = this.el.querySelector(`[data-slide-text="${slideKey}"`);
                    targetText.classList.add('is-visible');
                },
                onEnterBack: () => {
                    const slideKey = slide.getAttribute('data-slide-image');
                    const targetText = this.el.querySelector(`[data-slide-text="${slideKey}"`);
                    targetText.classList.add('is-visible');
                },
                onLeave: () => {
                    const slideKey = slide.getAttribute('data-slide-image');
                    const targetText = this.el.querySelector(`[data-slide-text="${slideKey}"`);
                    targetText.classList.remove('is-visible');
                },
                onLeaveBack: () => {
                    const slideKey = slide.getAttribute('data-slide-image');
                    const targetText = this.el.querySelector(`[data-slide-text="${slideKey}"`);
                    targetText.classList.remove('is-visible');
                }
            });
        });
    }
}
